import { Component } from '@angular/core';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { UsersService } from '../../../../Core/Users/services/users.service';
import { TableComponent } from '../../../../Common/Forms/components/Table/table.component';
import { getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { TableColumnModel } from '../../../../Common/Forms/models/table-column.model';

@Component({
    selector: 'agpr-social-table',
    templateUrl: './social-table.component.html',
    styleUrls: ['./social-table.component.scss'],
    providers: [getProvider(SocialTableComponent)],
    standalone: false
})
export class SocialTableComponent extends TableComponent {
    selectAll: boolean = false;
    constructor(
        protected currentUserService: CurrentUserStateService,
        protected usersService: UsersService
    ) {
        super(currentUserService, usersService);
    }

    selectAllRows(checked: boolean, column: TableColumnModel) {
        this.sortedData.forEach(row => {
            row[column.field] = checked;
            this.itemChanged.emit(row);
        });
        this.onChange(this.rawData);
    }

    /**
     * Sets the state of a checkbox field
     */
    saveCheckboxValue(checked: boolean, column: TableColumnModel, row: any): void {
        super.saveCheckboxValue(checked, column, row);
        if (this.sortedData.filter(rowData => rowData[column.field] === true).length !== this.sortedData.length) {
            this.selectAll = false;
        } else {
            this.selectAll = true;
        }
    }
}
